function e(e){if(0===Object.keys(e).length)return{};const t=e;return Object.keys(e).forEach((e=>{null!==t[e]&&void 0!==t[e]&&""!==t[e]||delete t[e]})),t}export{e as default};
